import { render, staticRenderFns } from "./project.vue?vue&type=template&id=0218d1fc&scoped=true&"
import script from "./project.vue?vue&type=script&lang=js&"
export * from "./project.vue?vue&type=script&lang=js&"
import style0 from "./project.vue?vue&type=style&index=0&id=0218d1fc&lang=less&scoped=true&"
import style1 from "./project.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0218d1fc",
  null
  
)

export default component.exports